import { datadogRum } from "@datadog/browser-rum";
import * as Sentry from "@sentry/react";
import React from "react";
import ReactDOM from "react-dom";
import { HelmetProvider } from "react-helmet-async";
import Modal from "react-modal";
import { Provider } from "react-redux";
import {
  BrowserRouter,
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom";

// This CSS import has to come before the App component import
import "index.css";
import "modern-normalize/modern-normalize.css";

import configureRemoteAPI from "shared/utils/configureRemoteAPI";
import determineReleaseVersion from "shared/utils/determineReleaseVersion";

import App from "App";
import store from "store/store";

if (
  ["dev", "staging", "production"].includes(
    process.env.REACT_APP_VPC_NAME || ""
  ) &&
  process.env.NODE_ENV === "production"
) {
  const version = determineReleaseVersion(
    process.env.REACT_APP_VIEWER_FRONTEND_VERSION
  );

  Sentry.init({
    dsn: "https://f5b700b17dad44eba04c9cda0e70ffe3@sentry.pathwatch.io/3",
    environment: process.env.REACT_APP_VPC_NAME,
    release: version,
    integrations: [
      new Sentry.BrowserTracing({
        routingInstrumentation: Sentry.reactRouterV6Instrumentation(
          React.useEffect,
          useLocation,
          useNavigationType,
          createRoutesFromChildren,
          matchRoutes
        ),
      }),
    ],
    tracesSampleRate: 1.0,

    // Disabled to improve viewer performance, to stop
    // ... Sentry from "phoning home" on replaceState
    autoSessionTracking: false,
  });

  datadogRum.init({
    applicationId: "991ee939-948d-49dd-bb70-3708f47d7ce8",
    clientToken: "pubfd6dcdf9a0e2fa47f4a4f605223272b2",
    site: "datadoghq.com",
    service: "viewer",
    env: process.env.REACT_APP_VPC_NAME,
    version,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,

    // Enabled to improve viewer performance, to stop
    // ... datadog from "phoning home" on replaceState
    trackViewsManually: true,
  });
}

configureRemoteAPI();

Modal.setAppElement("#root");
ReactDOM.render(
  <React.StrictMode>
    <HelmetProvider>
      <Provider store={store}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </Provider>
    </HelmetProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
